import { ROUTES, STATE_AUTH_PARAMS } from '@/configs/constants';
// import { useStore } from '@/hooks/useStore';
// import yup from '@/services/yup';
// import { yupResolver } from '@hookform/resolvers/yup';
import { observer } from 'mobx-react-lite';
// import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
// import SignUpGoogleButton from './component/signupGoogleButton';
// import SignUpLineButton from './component/signupLineButton';
// import LoginTwitterButton from './component/signupTwitterButton';
import passKeyIcon from '@/assets/images/pngs/pass-key.png';
import bannerImg from '@/assets/images/pngs/banner-login.png';
import GoogleButton from '@/components/login-social-button/GoogleButton';
import TwitterButton from '@/components/login-social-button/TwitterButton';
import LineButton from '@/components/login-social-button/LineButton';

export default observer(function SignUpPage() {
    // hooks
    const { t } = useTranslation();
    const navigate = useNavigate();

    // store
    // const { authStore: { login } } = useStore();

    // validate schema
    // const validateSchema = yup.object().shape({
    //     email: yup
    //         .string()
    //         .email('form_error_validate.email')
    //         .required('form_error_validate.required'),
    //     password: yup.string().required('form_error_validate.required')
    // });

    // type FormData = yup.InferType<typeof validateSchema>;

    // state
    // const form = useForm<FormData>({
    //     resolver: yupResolver(validateSchema),
    //     mode: 'onChange',
    //     defaultValues: {
    //         email: '',
    //         password: ''
    //     }
    // });

    const handleLogin = () => {
        navigate(ROUTES.login.href);
    };

    const handlePassKeySignUp = () => {
        navigate(ROUTES.inputEmail.href);
    };

    return (
        <div className='w-screen h-screen bg-white'>
            <div className='mx-auto flex w-full h-full flex-col justify-start items-center'>
                <img src={bannerImg} alt='bannerImg' className='w-full h-[30%]' />
                <div className='w-full px-[32px] mt-[-32px] rounded-t-[24px] bg-white pt-[32px] space-y-[24px]'>
                    <h3 className='text-center font-bold text-[24px]'>{t('words_title.sign_up')}</h3>
                    <button onClick={handlePassKeySignUp} className='w-full py-[12px] font-semibold rounded-full border-borderGray border-[1px] flex justify-center items-center cursor-pointer content-center'>
                        <img src={passKeyIcon} alt='passkeyIcon' className='w-[24px] h-[24px]' />
                        <p className='ml-[10px] text-[15px] text-text '>{t('text.viaPassKey')}</p>
                    </button>
                    <GoogleButton state={STATE_AUTH_PARAMS.googleSignUp} />
                    <TwitterButton state={STATE_AUTH_PARAMS.xSignUp} />
                    <LineButton state={STATE_AUTH_PARAMS.lineSignUp} />
                </div>

                {/* <div>
                    <h1>Đăng nhập với web auth</h1>
                    <WebAuthButton></WebAuthButton>
                </div> */}

                <div className=' w-full flex justify-center items-center font-semibold pt-[24px] px-[32px]'>
                    <div className='border-t-[1px] border-borderGray pt-[24px] w-full text-center'>
                        <p className='text-black'>{t('messages.have_account')}</p>
                        <p onClick={handleLogin} className='ml-[4px] text-textBlue cursor-pointer'>{t('words_title.sign_in')}</p>
                    </div>
                </div>

            </div>
        </div>
    );
});
